import { AccessControlGate, FeatureAccessDenied } from '@components/common';
import { AccessControlCode } from '@shared/constants';
import React from 'react';

interface OutletCapability {
  enabled: boolean;
  title: string;
  description: string;
}

interface AccessControlledDashboardPageProps {
  control: AccessControlCode;
  title: string;
  description: string;
  children: React.ReactNode;
  /**
   * Extra gate for features that also require an outlet-level capability
   * (e.g. hardware requirements), checked in addition to `control`.
   */
  outletCapability?: OutletCapability;
}

export const AccessControlledDashboardPage: React.FC<
  AccessControlledDashboardPageProps
> = ({ control, title, description, children, outletCapability }) => {
  if (outletCapability && !outletCapability.enabled) {
    return (
      <FeatureAccessDenied
        title={outletCapability.title}
        description={outletCapability.description}
      />
    );
  }

  return (
    <AccessControlGate
      control={control}
      fallback={<FeatureAccessDenied title={title} description={description} />}
    >
      {children}
    </AccessControlGate>
  );
};
